import React from "react";
import { useSelector } from "react-redux";
import style from "./CategoryTable.module.css";

const CategoryTable = () => {
  const budgetData = useSelector((state) => state.user);
  const expenseData = useSelector((state) => state.expense);

  // Helper function to determine Limit Status
  const getLimitStatus = (budget, expense) => {
    return Number(expense) > Number(budget) ? "Exceed" : "Within";
  };

  // Helper function to calculate the balance
  const getBalance = (budget, expense) => {
    return Number(budget) - Number(expense);
  };
 
  return (
    <table border={1} className={style.table}>
      <thead>
        <tr>
          <th>Category</th>
          <th>Limit Status</th>
          <th>Budget</th>
          <th>Expense</th>
          <th>Balance</th>
        </tr>
      </thead>
      <tbody>
        {/* Overall (All) Row */}
        <tr>
          <td>All</td>
          <td>
            {getLimitStatus(budgetData.monthlyBudget, expenseData.totalExpense)}
          </td>
          <td>{budgetData.monthlyBudget}</td>
          <td>{expenseData.totalExpense}</td>
          <td>
            {getBalance(budgetData.monthlyBudget, expenseData.totalExpense)}
          </td>
        </tr>
        {/* Food Row */}
        <tr>
          <td>Food</td>
          <td>
            {getLimitStatus(
              budgetData.categoricalBudget?.food,
              expenseData.categoricalExpense?.food
            )}
          </td>
          <td>{budgetData.categoricalBudget?.food}</td>
          <td>{expenseData.categoricalExpense?.food}</td>
          <td>
            {getBalance(
              budgetData.categoricalBudget?.food,
              expenseData.categoricalExpense?.food
            )}
          </td>
        </tr>
        {/* Travel Row */}
        <tr>
          <td>Travel</td>
          <td>
            {getLimitStatus(
              budgetData.categoricalBudget?.travel,
              expenseData.categoricalExpense?.travel
            )}
          </td>
          <td>{budgetData.categoricalBudget?.travel}</td>
          <td>{expenseData.categoricalExpense?.travel}</td>
          <td>
            {getBalance(
              budgetData.categoricalBudget?.travel,
              expenseData.categoricalExpense?.travel
            )}
          </td>
        </tr>
        {/* Entertainment Row */}
        <tr>
          <td>Entertainment</td>
          <td>
            {getLimitStatus(
              budgetData.categoricalBudget?.entertainment,
              expenseData.categoricalExpense?.entertainment
            )}
          </td>
          <td>{budgetData.categoricalBudget?.entertainment}</td>
          <td>{expenseData.categoricalExpense?.entertainment}</td>
          <td>
            {getBalance(
              budgetData.categoricalBudget?.entertainment,
              expenseData.categoricalExpense?.entertainment
            )}
          </td>
        </tr>
        {/* Others Row */}
        <tr>
          <td>Others</td>
          <td>
            {getLimitStatus(
              budgetData.categoricalBudget?.others,
              expenseData.categoricalExpense?.others
            )}
          </td>
          <td>{budgetData.categoricalBudget?.others}</td>
          <td>{expenseData.categoricalExpense?.others}</td>
          <td>
            {getBalance(
              budgetData.categoricalBudget?.others,
              expenseData.categoricalExpense?.others
            )}
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default CategoryTable;
